// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"324":"bdf5b6e6","389":"b5dbe407","423":"5c518107","561":"705809bf","714":"6632721b","731":"7fe8aeae","770":"46231ab2","771":"e4501a68","776":"93d2f02c","910":"622404fe","943":"7a9b5c89"}[chunkId] + ".chunk.js";
};